import { BaseTeachingElement } from "./BaseTeachingElement";

/**
 * Данные одного пропуска.
 */
export interface GapElementModel {

    /**
     * Индекс задания.
     */
    taskIndex: number;

    /**
     * Идентификатор gap внутри задания.
     */
    gapId: number;

    /**
     * Правильный ответ.
     */
    answer: string;

    /**
     * Рекомендуемая ширина input.
     */
    length: number;

    /**
     * Текущее значение пользователя.
     */
    value: string;

    /**
     * Показывается ли ответ.
     */
    revealed: boolean;

    events: {

        valueChanged(
            value: string
        ): void;

    };

}

/**
 * Interactive Gap.
 *
 * Не содержит учебной логики.
 */
export class GapElement extends BaseTeachingElement {

    private model: GapElementModel;

    constructor(
        model: GapElementModel
    ) {

        super();

        this.setModel(model);

    }

    public setModel(
        model: GapElementModel
    ): void {

        this.model = model;

    }

    public override mount(): void {

        this.root = document.createElement("span");
        this.root.className = "gap-wrap";

        const input = document.createElement("input");

        input.type = "text";
        input.className = "gap-input";

        input.style.width =
            `${Math.max(this.model.length * 1.3, 2)}ch`;

        input.value = this.model.value;

        if (this.model.revealed) {
            input.disabled = true;
        }

        this.root.appendChild(input);

        input.addEventListener(
            "input",
            () => {

                this.model.events.valueChanged(
                    input.value
                );

            }
        );

        if (this.model.revealed) {

            const answer =
                document.createElement("span");

            answer.className = "gap-answer";
            answer.textContent = this.model.answer;

            this.root.appendChild(answer);

        }

    }

    public override update(): void {

        const input =
            this.root.querySelector<HTMLInputElement>(
                ".gap-input"
            );

        if (input) {

            if (input.value !== this.model.value) {
                input.value = this.model.value;
            }

            input.disabled = this.model.revealed;

        }

    }

    public override unmount(): void {
    }

}